import { HelmetProvider } from 'react-helmet-async';
import { SEO, generateOrganizationSchema, generateWebSiteSchema } from './SEO';

/**
 * SEO Provider - Wraps the app with Helmet provider and global SEO
 */
export const SEOProvider = ({ children }) => {
  // Combined schema for the entire site
  const globalSchema = {
    '@context': 'https://schema.org',
    '@graph': [
      generateOrganizationSchema(),
      generateWebSiteSchema()
    ]
  };

  return (
    <HelmetProvider>
      {/* Global SEO defaults */}
      <SEO
        description="LinkTheMissing connects communities to help locate missing persons nationwide. Search 25,000+ cases, submit anonymous tips, and help bring families together."
        schema={globalSchema}
      />
      {children}
    </HelmetProvider>
  );
};

export default SEOProvider;
